import React, { useEffect, useMemo, useRef, useState } from "react";
import Loader from "../loader/loader";
import AccessDenied from "./accessDenied";
import AllowedTo from "./rbac";
import {
  IStandard,
  IUnAssociatedStandardRequest,
} from "../../../model/interface/standard";
import { ISelectElement } from "../../../model/interface/keyValuePair";
import Permissions from "../../../utils/permissions";
import {
  associateVideoStandards,
  associateWorksheetStandards,
  associateSlideStandards,
  getUnAssociatedStandards,
} from "../../../api/standard.service";
import { Link } from "react-router";
import {
  CaretDownSolidIcon,
  CaretUpSolidIcon,
  LinkIcon,
  CopyIcon,
} from "../../../assets/icons";
import Constant from "../../../utils/constant";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import Pagination from "../../shared/common/pagination";
import ConfirmationPopup from "./confirmationPopup";
import constant from "../../../utils/constant";
import MultiInput from "./multiInput";
import debounce from "lodash.debounce";
import MultiSelect from "../../shared/common/multiSelect";
import { getGradeAll } from "../../../api/subject.service";
import { associateQuestionStandards } from "../../../api/question.service";
interface StandardSearchProps {
  contentAreadId?: number;
  gradeLevel?: string;
  paramType: string;
  paramId: number;
  updateStandardsList: any;
}

function StandardSearch(props: StandardSearchProps) {
  const [gradeLevels, setGradeLevels] = useState<ISelectElement[]>([]);
  const [selectedGrades, setSelectedGrades] = useState<ISelectElement[]>([]);
  const [standardDetails, setStandardDetails] = useState<IStandard[]>([]);
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const defaultPageNumber = 1;
  const defaultPageSize = 10;
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [pageNumber, setPageNumber] = useState(defaultPageNumber);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [sortAscending, setSortAscending] = useState<boolean>(true);
  const [orderByColumn, setOrderByColumn] = useState<string>("subjectname");
  const [sortDir, setSortDir] = useState<string>("asc");
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);
  const [options, setOptions] = useState<any>([]);
  const [selectedNames, setSelectedNames] = useState<any>([]);
  const [isLoaded, setIsLoaded] = useState<boolean>(false);
  const [grades, setGrades] = useState<any>([]);
  const [showActive, setShowActive] = useState<boolean>(true);
  const [selectAll, setSelectAll] = useState<boolean>(false);
  const [selectedStandards, setSelectedStandards] = useState<Array<number>>([]);
  const [searchStandardIds, setSearchStandardIds] = useState<string>("");
  function bindGrades() {
    let newGradeData = [];
    getGradeAll(999, 1).then((response) => {
      const data = response.data.data;
      if (data.length > 0) {
        data.sort(
          (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
        );
        newGradeData = data.map((eachGradeData) => {
          return {
            value: eachGradeData.gradeId || 0,
            label: `${eachGradeData.name}`,
          };
        });
      }
      setGrades(newGradeData);
    });
  }

  function handleSort(columnName) {
    setShowLoading(true);
    setOrderByColumn(columnName);
    setSortAscending(!sortAscending);
    setSortDir(sortAscending ? "DESC" : "ASC");
  }

  function handleSearchClick(resetPageNumber?: boolean) {
    if (
      resetPageNumber &&
      pageNumber > Constant.DEFULT_PAGINATION.PAGE_NO_ONE
    ) {
      paginationRef?.current?.onReset();
      return;
    }

    setIsLoaded(true);
    setShowLoading(true);
    let names = "";
    if (selectedNames.length)
      selectedNames.map((ds, index) => {
        names += '.*|"' + ds.label + '"';
        if (index + 1 < selectedNames.length) {
          names += " OR ";
        }
      });

    let gradeLevelString = "";
    if (gradeLevels.length > 0) {
      gradeLevels.map((g) => {
        gradeLevelString += g.value + ",";
      });
    }

    let selectedGradesString = "";
    if (selectedGrades.length > 0) {
      selectedGrades.map((g) => {
        selectedGradesString += g.value + ",";
      });
    }

    const request: IUnAssociatedStandardRequest = {
      questionId: props.paramType === "question" ? props.paramId : null,
      videoId: props.paramType === "video" ? props.paramId : null,
      worksheetId: props.paramType === "worksheet" ? props.paramId : null,
      slideId: props.paramType === "slide" ? props.paramId : null,
      contentAreaId: props.contentAreadId ?? 0,
      isActive: showActive,
      gradeLevel: gradeLevelString,
      grades: selectedGradesString,
      description: names,
      pageSize: pageSize,
      pageNumber: pageNumber,
      orderByColumn: orderByColumn,
      sortDir: sortDir,
      standardIds: searchStandardIds,
    };
    getUnAssociatedStandards(request).then((response) => {
      setShowLoading(false);
      setStandardDetails([...response.data.data]);
      setTotalPages(Math.ceil(response.data.totalRecords / pageSize));
      setTotalRecords(response.data.totalRecords);
    });
  }

  const onAllRemove = () => {
    setOptions([]);
    setSelectedNames([]);
  };

  /** Code to implement input type number to support all browsers */
  useEffect(() => {
    bindGrades();
    refreshGrids();
    const input = document.getElementById("standardId");
    if (input) {
      input.addEventListener("keypress", (e: any) => {
        const keyValue = e.key;
        if (!e.target.value && e.key == 0) {
          e.preventDefault();
        } else {
          if (!/[0-9.,]/.test(keyValue)) {
            e.preventDefault();
          }
        }
      });
    }

    const txtSearchText = document.querySelector("#txtSearchText");
    if (txtSearchText) {
      const multiSelectInput: any =
        txtSearchText.querySelector(".css-1xm099h-Input input") ||
        txtSearchText.querySelector(".css-z0e8fs-Input input");
      const multiSelectInputServer: any =
        txtSearchText.querySelector(".css-912qm0 input") ||
        txtSearchText.querySelector(".css-1446j1a input");

      if (multiSelectInput) {
        multiSelectInput?.addEventListener("input", debouncedChangeHandler);
      } else {
        multiSelectInputServer?.addEventListener(
          "input",
          debouncedChangeHandler
        );
      }

      const arrow: any = txtSearchText.querySelector(
        ".css-1hb7zxy-IndicatorsContainer"
      );
      if (arrow) {
        arrow.style.display = "none";
      }
    }

    const arrows: any = document.querySelector(".css-1wy0on6");
    if (arrows) {
      arrows.style.display = "none";
    }
  }, []);

  const onNameChange = (e) => {
    const menu: any = document.querySelector(".css-1nmdiq5-menu");

    if (menu) {
      menu.style.display = "none";
    }
    options.push({ label: e.target.value, value: e.target.value });
    setOptions([]);
    setOptions(options);
  };

  function handleSelectAll() {
    const val = !selectAll;
    setSelectAll(val);
    const allStandards = [...standardDetails];
    if (val) {
      allStandards.forEach((standard) => {
        standard["isChecked"] = true;
      });
    } else {
      allStandards.forEach((standard) => {
        standard["isChecked"] = false;
      });
    }

    const updatedStandards = allStandards
      .filter((s: any) => s.isChecked === true)
      .map((s) => s.standardId);

    setSelectedStandards(updatedStandards);
    setStandardDetails(allStandards);
  }
  function handleSelectedStandards(standardId: number) {
    let updatedStandards: Array<number> = selectedStandards;
    if (updatedStandards.some((r) => r === standardId)) {
      updatedStandards = updatedStandards.filter((r) => r !== standardId);
    } else {
      updatedStandards.push(standardId);
    }

    const allStandards = [...standardDetails];
    const standard = allStandards.find((s) => s.standardId === standardId);
    if (standard) {
      if (updatedStandards.indexOf(standardId) > -1)
        standard["isChecked"] = true;
      else standard["isChecked"] = false;
    }

    if (
      allStandards.length ===
      allStandards.filter((x) => x["isChecked"] === true).length
    ) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }

    setSelectedStandards(updatedStandards);
    setStandardDetails(allStandards);
  }

  function refreshGrids() {
    props.updateStandardsList();
    setSelectedStandards([]);
    handleSearchClick();
  }

  const handleLinkStandard = async (confirmAction: boolean) => {
    setShowConfirmation(false);
    if (confirmAction) {
      if (selectedStandards && selectedStandards.length > 0) {
        setShowLoading(true);
        switch (props.paramType) {
          case "question":
            await associateQuestionStandards(
              props.paramId,
              selectedStandards
            ).then(() => {
              refreshGrids();
            });
            break;
          case "video":
            await associateVideoStandards(
              props.paramId,
              selectedStandards
            ).then(() => {
              refreshGrids();
            });
            break;
          case "worksheet":
            await associateWorksheetStandards(
              props.paramId,
              selectedStandards
            ).then(() => {
              refreshGrids();
            });
            break;
          case "slide":
            await associateSlideStandards(
              props.paramId,
              selectedStandards
            ).then(() => {
              refreshGrids();
            });
            break;
        }
      }
    }
  };

  const debouncedChangeHandler = useMemo(() => debounce(onNameChange, 100), []);

  const handleStandardIdCopyClick = () => {
    // Retrieve clipboard data from localStorage
    const clipboardData = localStorage.getItem("clipboard");
    if (clipboardData) {
      const clipboard = JSON.parse(clipboardData);
      const items = clipboard.items || [];
      const idsList = items.join(", ");
      setSearchStandardIds(idsList);
    }
  };

  useEffect(() => {
    if (isLoaded) handleSearchClick();
  }, [pageNumber]);

  useEffect(() => {
    if (pageNumber === 1) {
      handleSearchClick();
    } else {
      paginationRef?.current?.onReset();
    }
  }, [pageSize]);

  useEffect(() => {
    if (isLoaded) {
      handleSearchClick();
    }
  }, [sortDir]);

  return (
    <AllowedTo perform={Permissions.standard_view} no={() => <AccessDenied />}>
      {showLoading && <Loader />}
      {showConfirmation && (
        <ConfirmationPopup
          title={"Associate Standard"}
          confirmAction={handleLinkStandard}
          message={
            "Are you sure you want to associate? It will associate the linked standards also."
          }
          buttonText={"Yes"}
        />
      )}
      <div className="mt-6 w-full">
        <h3 className="mb-6 text-lg font-light text-gray-900">
          Standard Search
        </h3>
        <div className="grid grid-cols-10 gap-5">
          <div className="col-span-3">
            <div className="self-center place-self-start text-sm col-span-2 dark:text-white">
              Search Text
            </div>
            <div className="mt-1 relative col-span-5">
              <MultiInput
                id="txtSearchText"
                options={options}
                selectedItems={selectedNames}
                setSelectedItems={setSelectedNames}
                onAllRemove={onAllRemove}
              />
            </div>
          </div>
          <div className="col-span-3">
            <div className="self-center place-self-start text-sm col-span-2 dark:text-white">
              Grade Level
            </div>
            <div className="mt-1 relative col-span-5">
              <MultiSelect
                options={constant.GradeLevelData}
                selectedItems={gradeLevels}
                setSelectedItems={setGradeLevels}
              />
            </div>
          </div>
          <div className="col-span-3">
            <div className="self-center place-self-start text-sm col-span-2 dark:text-white">
              Grade
            </div>
            <div className="mt-1 relative col-span-5">
              <MultiSelect
                options={grades}
                selectedItems={selectedGrades}
                setSelectedItems={setSelectedGrades}
              />
            </div>
          </div>
          <div className="ml-4 text-sm font-light text-gray-900 mt-8">
            <div className="flex gap-3 justify-end items-center absolute">
              <input
                type="checkbox"
                checked={!showActive}
                onChange={() => setShowActive(!showActive)}
              />
            </div>
            <span className="ml-6">Show Inactive</span>
          </div>
          <div className="col-span-3">
            <div className="flex">
              Standard Ids{" "}
              <CopyIcon
                className="h-5 cursor-pointer"
                title="Copy id"
                onClick={() => handleStandardIdCopyClick()}
              />
            </div>
            <div className="mt-1 relative col-span-5">
              <input
                id="standardId"
                type="text"
                className="focus:ring-primary-color focus:border-primary-color block w-full  pr-12 sm:text-sm border-gray-300 rounded-md"
                value={searchStandardIds}
                onChange={(e) => setSearchStandardIds(e.target.value)}
              />
            </div>
          </div>

          <div className="col-span-12 flex items-end justify-end">
            <button
              type="button"
              className="mt-2 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
              onClick={() => {
                setSelectedStandards([]);
                handleSearchClick(true);
              }}
            >
              Search
            </button>
          </div>
        </div>
        <div className="flex justify-end">
          <button
            type="button"
            onClick={(e) => setShowConfirmation(true)}
            className="mt-2 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
          >
            Associate
          </button>
        </div>
        <div className="text-gray-900 block px-4 py-4 text-sm shadow border-b border-gray-200 rounded-b-lg">
          <div id="dataContainer" className="mt-4">
            <div className="flex flex-col mt-1">
              <div className="sm:-mx-6 lg:-mx-8">
                <div className="align-middle inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="shadow overflow-x-auto border-b border-gray-200 sm:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-primary-color">
                        <tr>
                          <th></th>
                          <th className="pl-5 relative">
                            <input
                              type="checkbox"
                              checked={selectAll}
                              onClick={() => handleSelectAll()}
                            />
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white "
                          >
                            <span className="flex gap-2">
                              Subject
                              <span className="cursor-pointer">
                                {!sortAscending &&
                                orderByColumn === "subjectname" ? (
                                  <CaretUpSolidIcon
                                    onClick={() => handleSort("subjectname")}
                                    className="w-5 h-5"
                                  ></CaretUpSolidIcon>
                                ) : (
                                  <CaretDownSolidIcon
                                    onClick={() => handleSort("subjectname")}
                                    className="w-5 h-5"
                                  ></CaretDownSolidIcon>
                                )}
                              </span>
                            </span>
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white "
                          >
                            <span className="flex gap-2">
                              State{" "}
                              <span className="cursor-pointer">
                                {!sortAscending &&
                                orderByColumn === "statename" ? (
                                  <CaretUpSolidIcon
                                    onClick={() => handleSort("statename")}
                                    className="w-5 h-5"
                                  ></CaretUpSolidIcon>
                                ) : (
                                  <CaretDownSolidIcon
                                    onClick={() => handleSort("statename")}
                                    className="w-5 h-5"
                                  ></CaretDownSolidIcon>
                                )}
                              </span>
                            </span>
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white "
                          >
                            <span className="flex gap-2">
                              Domain{" "}
                              <span className="cursor-pointer">
                                {!sortAscending &&
                                orderByColumn === "domainname" ? (
                                  <CaretUpSolidIcon
                                    onClick={() => handleSort("domainname")}
                                    className="w-5 h-5"
                                  ></CaretUpSolidIcon>
                                ) : (
                                  <CaretDownSolidIcon
                                    onClick={() => handleSort("domainname")}
                                    className="w-5 h-5"
                                  ></CaretDownSolidIcon>
                                )}
                              </span>
                            </span>
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-2 pl-6 font-light text-sm text-left text-white dark:text-white tracking-wider"
                          >
                            <span className="flex gap-2">
                              Standard
                              <span className="cursor-pointer">
                                {!sortAscending && orderByColumn === "name" ? (
                                  <CaretUpSolidIcon
                                    onClick={() => handleSort("name")}
                                    className="w-5 h-5"
                                  ></CaretUpSolidIcon>
                                ) : (
                                  <CaretDownSolidIcon
                                    onClick={() => handleSort("name")}
                                    className="w-5 h-5"
                                  ></CaretDownSolidIcon>
                                )}
                              </span>
                            </span>
                          </th>
                          <th
                            scope="col"
                            className="px-3 py-2 font-light whitespace-wrap text-sm text-left text-white dark:text-white  "
                          >
                            Description
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {standardDetails.map((standard: any, index) => (
                          <tr
                            key={standard.standardId}
                            className={
                              index % 2 === 0 ? "bg-white" : "bg-gray-100"
                            }
                          >
                            <td className="pl-5 relative">
                              {standard.isActive ? (
                                <span className="mr-1 h-4/5 w-0.5  bg-green-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                              ) : (
                                <span className="mr-1 h-4/5 w-0.5  bg-red-500 rounded-md inline-block absolute top-0 left-1.5"></span>
                              )}
                              {standard.isLinked && (
                                <LinkIcon
                                  className={`cursor-not-allowed w-5 ${
                                    standard.isLinked ? "" : "opacity-50"
                                  }`}
                                />
                              )}
                            </td>
                            <td className="pl-5 relative">
                              <input
                                type="checkbox"
                                checked={selectedStandards.includes(
                                  standard.standardId
                                )}
                                onClick={() =>
                                  handleSelectedStandards(standard.standardId)
                                }
                              />
                            </td>
                            <td className="px-3 py-2 whitespace-wrap text-sm text-left font-normal text-gray-500">
                              <Link
                                className={`ml-1 cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline`}
                                to={Constant.SUBJECTDETAIL.replace(
                                  ":id",
                                  standard.subjectId.toString()
                                )}
                              >
                                [{standard.subjectId}] {standard.subjectName}
                              </Link>
                            </td>
                            <td className="px-3 py-2 whitespace-wrap text-sm text-left font-normal text-gray-500">
                              {standard.stateNames}
                            </td>
                            <td className="px-3 py-2 whitespace-wrap text-sm text-left font-normal text-gray-500">
                              <Link
                                to={Constant.EDITDOMAIN.replace(
                                  ":id",
                                  standard.domainId
                                    ? standard.domainId.toString()
                                    : ""
                                )}
                                className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                              >
                                {standard.domainName}
                              </Link>
                            </td>
                            <td className="px-3 py-2  pl-6 whitespace-wrap text-sm text-left font-normal text-gray-500">
                              <Link
                                to={Constant.EDITSTANDARD.replace(
                                  ":id",
                                  standard.standardId
                                    ? standard.standardId.toString()
                                    : ""
                                )}
                                className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                              >
                                {standard.standardIcon && (
                                  <img
                                    className="h-5 w-5 mr-2"
                                    src={standard.standardIcon}
                                  />
                                )}
                                [{standard.code}] {standard.name}
                              </Link>
                            </td>
                            <td className="px-3 py-2 whitespace-wrap text-sm font-normal text-gray-500">
                              {standard?.description}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
              <div
                className={`flex justify-between items-center ${
                  standardDetails.length === 0 ? "hidden" : ""
                }`}
              >
                <Pagination
                  pages={totalPages}
                  setPageNumber={setPageNumber}
                  ref={paginationRef}
                />
                <span>
                  <span className="text-sm pr-4 ml-auto text-left-700">
                    Showing {pageNumber} to{" "}
                    {totalRecords < pageSize ? totalRecords : pageSize} of{" "}
                    {totalRecords} results
                  </span>

                  <SelectPageSize
                    setPageSize={setPageSize}
                    type={"second"}
                    ref={pageSizeRef}
                  />
                </span>
              </div>

              {standardDetails.length === 0 && (
                <p className="p-2">No Records Found</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </AllowedTo>
  );
}

export default StandardSearch;
